import type { MiddlewareObj } from "@middy/core";
import type {
	APIGatewayEventCommon,
	ErrorContext,
	MiddlewareOptions,
} from "./types";
import { LambdaErrorUtility } from "./utility";

export { LambdaErrorUtility } from "./utility";

let errorContext: ErrorContext = {};

export function tryCatch({
	projectName,
	apiKey,
}: MiddlewareOptions): MiddlewareObj<APIGatewayEventCommon> {
	const tryCatchInstance = new LambdaErrorUtility(projectName, apiKey);

	return {
		before: () => {
			errorContext = {};
		},
		onError: async (req) => {
			await tryCatchInstance.sendErrorFromEndPoint(
				req.error,
				req.event,
				errorContext,
			);
		},
	};
}

export function addContext(ctx: ErrorContext) {
	errorContext = {
		...errorContext,
		...ctx,
	};
}
